import { Link } from "react-router-dom";
import { useDemoRequest } from "@/components/feature/DemoRequest";

export default function AboutCTA() {
  const { open } = useDemoRequest();
  return (
    <section className="py-16 md:py-24 bg-graphite-850 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-accent/5 via-transparent to-transparent"></div>
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
            Ready to Move From Fragmented Tools to Structured Systems?
          </h2>
          <p className="text-base md:text-lg text-silver-300 mb-8 max-w-2xl mx-auto leading-relaxed">
            StackMap Systems helps businesses move from fragmented, manual operations to structured, intelligent systems. We provide the foundation that allows organizations to operate efficiently, make better decisions, and scale with confidence.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={open} className="btn-primary w-full sm:w-auto text-center cursor-pointer">Get in Touch</button>
            <Link to="/products" className="btn-outline w-full sm:w-auto text-center">
              Explore Our Work
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
